import pino from 'pino';

const formatTimestamp = () => {
  const date = new Date();
  const jstOffsetMs = 9 * 60 * 60 * 1000;
  const jstDate = new Date(date.getTime() + jstOffsetMs);

  const pad = (num: number, size: number) => num.toString().padStart(size, '0');

  const year = jstDate.getUTCFullYear();
  const month = pad(jstDate.getUTCMonth() + 1, 2);
  const day = pad(jstDate.getUTCDate(), 2);
  const hour = pad(jstDate.getUTCHours(), 2);
  const minute = pad(jstDate.getUTCMinutes(), 2);
  const second = pad(jstDate.getUTCSeconds(), 2);
  const millisecond = pad(jstDate.getUTCMilliseconds(), 3);

  return `${year}-${month}-${day}T${hour}:${minute}:${second}.${millisecond}+09:00`;
};

const timestamp = () => `,"time":"${formatTimestamp()}"`;

export const logger = pino({
  level: 'info',
  timestamp,
});
